<chart [type]="'bar'"
       [data]="chartData"
       [options]="options"
       [height]="250"
       [width]="width">
</chart>
